/** GlobalConfig 跟單相關欄位預設值 */
export const DEFAULT_FOLLOW_GLOBAL_SETTINGS = {
  futureFollowOpen: true,
  followSignalsOpen: false,
  showFollowOrderButton: true,
};

function toBoolean(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') {
      return true;
    }
    if (normalized === 'false' || normalized === '0') {
      return false;
    }
  }
  return Boolean(value);
}

/**
 * 從 tenant-config 列表取出指定 itemKey 的 content。
 */
export function findTenantConfigContent(list, itemKey) {
  if (!Array.isArray(list) || !itemKey) {
    return null;
  }
  const matched = list.find((item) => item?.itemKey === itemKey);
  return matched?.content ?? null;
}

/**
 * 從 GlobalConfig content 取出跟單三開關。
 */
export function pickFollowGlobalSettings(content) {
  const source = content && typeof content === 'object' ? content : {};
  return {
    futureFollowOpen: toBoolean(
      source.futureFollowOpen,
      DEFAULT_FOLLOW_GLOBAL_SETTINGS.futureFollowOpen
    ),
    followSignalsOpen: toBoolean(
      source.followSignalsOpen,
      DEFAULT_FOLLOW_GLOBAL_SETTINGS.followSignalsOpen
    ),
    showFollowOrderButton: toBoolean(
      source.showFollowOrderButton,
      DEFAULT_FOLLOW_GLOBAL_SETTINGS.showFollowOrderButton
    ),
  };
}

/**
 * 從 tenant-config 列表解析跟單三開關。
 */
export function pickFollowGlobalSettingsFromTenantList(list) {
  return pickFollowGlobalSettings(findTenantConfigContent(list, 'global'));
}

/**
 * 將跟單開關 patch 回 GlobalConfig content（供 save/one 合併寫入）。
 */
export function patchFollowGlobalSettings(content, patch) {
  const base = content && typeof content === 'object' ? { ...content } : {};
  return {
    ...base,
    ...patch,
  };
}
